
import Vue from "vue";
import { Confirm, ConfirmResult } from "../classes/confirm";
import { Dialog } from "../classes/dialog";
import { WfNotification } from "../classes/notification";
import eventBus from "../event-bus";

export default Vue.extend({
	data() {
		let wf = this.$wf;
		return {
			wf,
			dialogs: [] as Dialog[],
			confirms: [] as Confirm[],
			notifications: [] as WfNotification[],
		};
	},
	computed: {
		notificationTransition():string {
			return "slide-left";
		},
	},
	methods: {
		dismissDialog(dialog:Dialog) {
			dialog.onDismis();
			let i = this.dialogs.indexOf(dialog);
			this.dialogs.splice(i, 1);
		},
		confirmCancelClicked(confirm:Confirm) {
			this.dismissConfirm(confirm, ConfirmResult.CANCEL);
		},
		confirmYesClicked(confirm:Confirm) {
			this.dismissConfirm(confirm, ConfirmResult.YES);
		},
		confirmNoClicked(confirm:Confirm){
			this.dismissConfirm(confirm, ConfirmResult.NO);
		},
		dismissConfirm(confirm:Confirm, res:ConfirmResult){
			confirm.onDismiss(res);
			let i = this.confirms.indexOf(confirm);
			this.confirms.splice(i, 1);
		},
		dismissNotification(i:number) {
			this.notifications.splice(i, 1);
		},

		onEventBusDialog(item:Dialog){
			if (document.activeElement) {
				if ((document.activeElement as any).blur) {
					(document.activeElement as any).blur();
				}
			}
			this.dialogs.push(item);
		},
		onEventBusConfirm(item:Confirm){
			if (document.activeElement) {
				if ((document.activeElement as any).blur) {
					(document.activeElement as any).blur();
				}
			}
			this.confirms.push(item);
		},
		onEventBusNotification(item:WfNotification){
			this.notifications.push(item);
		},
		onKeyUp(e:KeyboardEventInit){
			if (this.dialogs.length != 0) {
				if (e.key == "Enter") {
					this.dismissDialog([...this.dialogs].pop() as any as Dialog);
				}
			}
			if (this.confirms.length != 0) {
				let confirm = [...this.confirms].pop() as any as Confirm;
				if (e.key == "Enter") {
					this.dismissConfirm(confirm, ConfirmResult.YES);
				} else if (e.key == "Escape") {
					if (confirm.cancelText){
						this.dismissConfirm(confirm, ConfirmResult.CANCEL);
					}else{
						this.dismissConfirm(confirm, ConfirmResult.NO);
					}
				}
			}
		}
	},
	created() {
		eventBus.$on("dialog", this.onEventBusDialog);
		eventBus.$on("confirm", this.onEventBusConfirm);
		eventBus.$on("notification", this.onEventBusNotification);
		window.addEventListener("keyup", this.onKeyUp);
	},
	destroyed(){
		eventBus.$off("dialog", this.onEventBusDialog);
		eventBus.$off("confirm", this.onEventBusConfirm);
		eventBus.$off("notification", this.onEventBusNotification);
		window.removeEventListener("keyup", this.onKeyUp);
	}
});
